import React from "react"

export default () => <h1>Whoops!</h1>
